import config from '../nyConfig'
const ApiAssess = {
    "测评列表": new config({ url: '/assess/assessList', showSuccessMessage: false, useToken: true }),
    "测评字典列表": new config({ url: '/assess/assessDictionary', showSuccessMessage: false, useToken: true }),
    "添加测评": new config({ url: '/assess/assessAdd', showSuccessMessage: true, useToken: true }),
    "编辑测评": new config({ url: '/assess/assessEdit', showSuccessMessage: true, useToken: true }),
    "公司测评": new config({ url: '/assess/companyAssess', showSuccessMessage: false, useToken: true }),
    "报告导出": new config({ url: '/assess/exportReport', showSuccessMessage: false, useToken: true }),
}

export default ApiAssess